import httpClient from "../../api/httpClient";
import { createWrappedAsyncThunk } from "../createWrappedAsyncThunk";

export const getMe = createWrappedAsyncThunk("user/getMe", async () => {
  return await httpClient.get(`get-me`);
});

export const getRegions = createWrappedAsyncThunk(
  "user/getRegions",
  async () => {
    return await httpClient.publicGet(`regions`);
  }
);

export const saveTenant = createWrappedAsyncThunk(
  "user/saveTenant",
  async (payload) => {
    return await httpClient.put(`tenant`, payload);
  }
);

export const saveProfile = createWrappedAsyncThunk(
  "user/saveProfile",
  async (payload) => {
    return await httpClient.put(`user`, payload);
  }
);

export const getTenantDetailsById = createWrappedAsyncThunk(
  "user/getTenantDetailsById",
  async ({ tenant_id }) => {
    const { data } = await httpClient.get(`tenants`, {
      params: {
        tenant_id,
      },
    });
    return { data: data?.[0] || {} };
  }
);
